import { render, staticRenderFns } from "./AlugueisDoDia.vue?vue&type=template&id=cf08beb6&"
import script from "./alugueisDoDia.js?vue&type=script&lang=js&"
export * from "./alugueisDoDia.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports